import moment from "moment";
import { useContext, useEffect, useRef, useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { MdAttachFile } from "react-icons/md";
import { RiSendPlaneFill } from "react-icons/ri";
import { AuthContext } from "../../states/AuthContext";
import { arrayUnion, doc, getDoc, onSnapshot, setDoc, Timestamp, updateDoc } from "firebase/firestore";
import { db } from "../../services/Firebase";
import { errorAlert } from "../../components/common/Alert";
import { sendChatNotification } from "../../services/Networkcall";

export default function SupportPage() {

  const { userProfileData } = useContext(AuthContext);
  const [messages, setMessages] = useState([]);
  const [loadingMessages, setLoadingMessages] = useState(true);
  const [text, setText] = useState('');

  const receiverId = "adminUser";
  const userId = userProfileData?._id;
  const combinedId = `${userId},${receiverId}`;

  const chatEndRef = useRef();

  const convertToUtcLocalDate = (date) => {
    return moment(date.toDate()).local().format('YYYY-MM-DD hh:mm A')
  }


  //=========Real time listner of chat messages=============
  useEffect(() => {
    if (combinedId) {
      setLoadingMessages(true);
      const chatDocRef = doc(db, 'chat_messages', combinedId)
      const unsubscribe = onSnapshot(chatDocRef, (doc) => {
        if (doc.exists()) {
          const fetchMessages = doc?.data?.messages || [];
          setMessages(fetchMessages)
        } else {
          console.log('Chat document does not exist yet.');
        }
        setLoadingMessages(false)
      })
      return () => unsubscribe();
    }
  }, [combinedId])


  // ==============SCROLL TO BOTTOM ON CHAT ================
  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: 'auto' });
    }
  }, [messages]);

  // ====================HANDLE SEND MESSAGE=================
  const sendMessageHandler = async (message) => {
    // Validation 
    if (!message?.trim())  return; 
    setText("");

    // Firebase timestamp  
    const time = Timestamp.now();

    try {

      // Chat Document Check
      const res = await getDoc(doc(db, 'chat_messages', combinedId))

      if (!res?.exists()) {
        // creating document
        await setDoc(doc(db, 'chat_messages', combinedId))
      }

      // Chat Room Update
      await updateChatRoom(message);

      // Message Save
      await updateDoc(doc(db, 'chat_messages', combinedId), {
        messages: arrayUnion({
          text: message,
          senderId: userId,
          date: time,
          receiverId: receiverId,
          seen: false,
        })
      })

      // Notification
      sendChatNotification({ message })

    } catch (err) {
      errorAlert({message: err?.response?.data?.message || err?.message || "something went wrong." });
      console.log("chat error - ", err)
    }
  }


  // ====================UPDATE CHAT ROOM=================
  const updateChatRoom = async (lastMessage) => {
    // Validation
    if (!receiverId) {
      throw new Error("User is not authenticated")
    }

    // Admin chat room document
    const documentRef = doc(db, "chat_messages", receiverId);

    // ─── Document Check ──────────────────────────────
    const snapshot = await getDoc(documentRef);

    if (snapshot.exists()) {
      const data = snapshot.data();
      const users = data?.users || [];

      // find user
      const userIndex = users.findIndex((user) => user.userId === userId);

      // new user as userindex is -1
      if (userIndex === -1) {
        users.push({
          userId: userId,
          userName: userProfileData?.userName,
          profileImage: userProfileData?.profileImage,
          createdAt: Timestamp.now(),
          lastMessage: lastMessage,
          lastMessageCreatedAt: Timestamp.now(),
        });
      } else {
        // existing user
        users[userIndex].lastMessage = lastMessage;
        users[userIndex].lastMessageCreatedAt = Timestamp.now();
      }

      // Document update
      await setDoc(documentRef, { users }, { merge: true });

    } else {
      // Document Hi Nahi Hai create fresh chat_rooms document of admin with first user 
      await setDoc(documentRef, {
        users: [{
          userId: userId,
          createdAt: Timestamp.now(),
          lastMessage: lastMessage,
          lastMessageCreatedAt: Timestamp.now(),
          userName: userProfileData.userName,
          profileImage: userProfileData.profileImage,
        }],
      });
    }
  }

    

  return (
    <div className="support-page">
      <Card className="support-card">

        <div className="support-header">
          <h5>Support Chat</h5>
          <span>We’re here to help</span>
        </div>
        <div className="chat-box">
          {messages.map((msg, i) => (
            <div key={i}>

              {(i === 0 || messages[i - 1].date !== msg.date) && (
                <div className="date-divider">{msg.date}</div>
              )}

              <div className={`chat-row ${msg.from}`}>
                <div className="chat-message">

                  {msg.text && (
                    <div className="msg-text">{msg.text}</div>
                  )}

                  {msg.file && (
                    <div className="file-box">
                      {msg.fileType?.startsWith("image") ? (
                        <img src={msg.file} alt="file" />
                      ) : (
                        <a href={msg.file} target="_blank" rel="noreferrer">
                          📄 {msg.fileName}
                        </a>
                      )}
                    </div>
                  )}

                  <div className="msg-meta">{msg.time}</div>

                </div>
              </div>

            </div>
          ))}
        </div>

        <div className="chat-input">

          {/* <input
            type="file"
            id="fileUpload"
            hidden
            onChange={(e) => setFile(e.target.files[0])}
          /> */}

          {/* <label htmlFor="fileUpload" className="file-btn">
            <MdAttachFile />
          </label> */}

          <Form.Control
            placeholder="Type your message..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      sendMessageHandler(text);
                    }
                  }}
          />

          <Button onClick={()=>{sendMessageHandler(text)}}>
            <RiSendPlaneFill />
          </Button>

        </div>

      </Card>
    </div>
  );
}